<template>
    <div class="row mx-0 px-2 header-bg" v-if="columns && columns.titles">
        <div v-for="(title, i) in columns.titles" :class="`col-${columns.col[i]} px-1`">
            <span class="small text-uppercase text-white">{{ title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "TrackerNewDataHeader",
    props: ["columns"],
};
</script>

<style scoped>
.header-bg {
    background-color: #323336;
}
</style>
